const selectLogEntries = (state) => state.logEntries;
export default selectLogEntries;
